import React, {useState, useEffect, useLayoutEffect, useRef} from 'react';
import useInterval from '../../../../customHooks/useInterval';



const TIME_INTERVAL = 100
const TrainEnthusiastEvent = props => {
    const [eventActive, setEventActive] = useState(true);
    const [eventOver, setEventOver] = useState(false);


    // ref for starting stopping animation 
    const liftCrossingArm = useRef()
    const handSignaling = useRef(false)
    
    const currentTime = useRef(0)
    const eventsToProcess = useRef(props?.data?.timedEvents.map( e => ({ ...e, processed: false})) || [])

    // Arm Animation state/modifiers
    const [leftArmAnimation, setLeftArmAnimation ] = useState({
        isAnimating:  false,
        currentState: 0,
        animationSpeed: 100
    })

 
    
    function animateLifting(direction = 'up' ) {
        if (direction === 'up') {
            setLeftArmAnimation((curr) => {
                if (curr.currentState < 6) {
                    return {
                        ...curr,
                        isAnimating: true,
                        currentState: curr.currentState + 1,
                    }
                }
                return {
                    ...curr,
                    isAnimating: false
                }
            })
            return
        } else if (direction === 'down') {
            setLeftArmAnimation((curr) => {
                if (curr.currentState > 0 && curr.currentState !== 7) {
                    return {
                        ...curr,
                        isAnimating: true,
                        currentState: curr.currentState - 1,
                    }
                }
                return {
                    ...curr,
                    currentState: 7, // amr down/hand to the side 

                    isAnimating: false
                }
            })
        }
    }
    // Hand Signaling State/Modifiers
    const [handSignalingAnimation,setHandSignalingAnimation ] = useState({
        isAnimating: false,
        currentState: 0,
        animationSpeed:500
    })

    function animateHandSignaling() {
       setHandSignalingAnimation( (curr) => {
           if (curr.currentState < 20 ) {
               return {
                   ...curr,
                   isAnimating: true,
                   currentState: curr.currentState + 1,
               }
           }
           return {
               ...curr,
               isAnimating: false
           }
       })
    }


    // Arm Animation Interval
    useEffect( () => {
        const handSignalingInterval = setInterval( () => {

            if (handSignaling.current === true ) {
                    animateHandSignaling()
                }
                 
            }, handSignalingAnimation.animationSpeed)
        
        
        const liftCrossingArmSignaling = setInterval( () => {

            if (liftCrossingArm.current === 'up'  || liftCrossingArm.current === 'down') {
                animateLifting(liftCrossingArm.current)
            }
            
        }, 100)
        const mainInterval = setInterval(() => {
            if (eventActive && !eventOver){
                eventsToProcess.current && eventsToProcess.current.forEach((e,i)=> {
                    if (e.processed === true) return;
                    if (e.time > currentTime.current) return
                    eventsToProcess.current[i].processed = true

                    switch (e.event) {
                        case 'move_right_arm':
                            console.log("ENTH: Animate Right Arm",e)
                            liftCrossingArm.current = e.value
                            break
                        case 'hand_signaling':
                            console.log("Hand signaling!")
                            handSignaling.current = true
                            break
                        default:
                            console.log(`Unhandled event of type: ${e.event} at ${e.time}`)
                            break
                    }
                })
            }
            currentTime.current += TIME_INTERVAL
        }, TIME_INTERVAL)



        setEventActive(true)
            return () => {
                clearInterval(handSignalingInterval)
                clearInterval(liftCrossingArmSignaling)
                clearInterval(mainInterval)
            }
    }, [])
    

    const styleObject = {
        zIndex: props.zIndex,
        transform: `translate3d(${
            props.xOffset
        }%, ${
            props.yOffset
        }%, ${
            props.zOffset
        }px)`
    }

   

    return (
        <div className={`TrainEnthusiastEvent`} style={styleObject}>
            <div className={`enthusiast `}>
                <div className={`torso`} />
                <div className={`left-arm state-${leftArmAnimation.currentState}`} />
                <div className={`right-arm state-${handSignalingAnimation.currentState}`} />
            </div>
          
        </div>
    )
}

export default TrainEnthusiastEvent
